import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";

const GlobalMira = ({
  open,
  output,
  error,
  isLoading = false,
  retryHandler,
  buttonText = "Generate",
  userInput,
  handleUserInput,
  onPress,
  onClose,
  showCopyToClipboard,
  customButton,
  showTextArea,
  showOutputArea,
  handleOutputChange,
}) => {
  const [copied, setCopied] = useState(false);

  //Function to copy user input to clipboard

  const handleCopy = () => {
    navigator.clipboard.writeText(userInput);
    setCopied(true);

    //resets the copied state after 3 seconds
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Mira Prompt
        {showCopyToClipboard && (
          <Tooltip title={copied ? "Copied!" : "Copy to Clipboard"}>
            <IconButton
              onClick={handleCopy}
              color="secondary"
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        )}
      </DialogTitle>
      <DialogContent>
        <>
          {showOutputArea && (
            <>
              {isLoading ? (
                <CircularProgress />
              ) : (
                <>
                  {error && <Typography>An error occurred</Typography>}
                  <TextField
                    fullWidth
                    label="Output"
                    value={output}
                    onChange={(e) => handleOutputChange(e.target.value)}
                  />
                </>
              )}
            </>
          )}
          {showTextArea && (
            <TextField
              fullWidth
              label="Enter your input"
              value={userInput}
              onChange={(e) => handleUserInput(e.target.value)}
            />
          )}
        </>
      </DialogContent>
      <DialogActions>
        {error && retryHandler && <Button onClick={retryHandler}>Retry</Button>}
        {customButton ? (
          React.cloneElement(customButton, {
            onClick: (event) => {
              customButton.props.onClick?.(event); //If custom button has onClick function, it runs first
              onPress(); //ensure mira's onPress function still runs
            },
          })
        ) : (
          <Button onClick={() => onPress()} variant="contained" disabled={isLoading}>
            {buttonText}
          </Button>
        )}
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalMira;
